module.exports = __webpack_public_path__ + "static/bg-customer-1-b60a09c05936b5e40212f65e8db427ab.jpg";